import useHandleAppException, { AppExceptionResponse } from '../../../hooks/useHandleAppException';
import snackbarStore from '../../../stores/Snackbar.store';
import { ActionEnum } from '../actions/types/orderActions.types';
import { useOrderActionsContext } from '../contexts/OrderActions.context';
import useGenerateContract from '../contract/hooks/useGenerateContract';

const useSignOrderFlow = (orderId: string, shouldISign: boolean) => {
  const { orderRaw, onClickOrderAction, onCloseModal } = useOrderActionsContext();
  const { generate, isGenerating } = useGenerateContract(orderId);
  const { handleErrorResponse } = useHandleAppException();

  const generateAndOpenContract = async () => {
    try {
      await generate();
      if (!orderRaw) {
        return;
      }

      shouldISign ? onClickOrderAction(ActionEnum.OPEN_CONTRACT_MODAL, orderRaw) : onCloseModal();
    } catch (error) {
      const message = handleErrorResponse(error as AppExceptionResponse);
      if (message) {
        snackbarStore.handleMessage({ type: 'error', message });
      }
    }
  };

  return { generateAndOpenContract, isGenerating };
};

export default useSignOrderFlow;
